import styled from "styled-components";
import { colorPalette, typeScale } from "../../utils/theme";
import MobileSidebarBg from "../../assets/images/sidebar-bg.jpg";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const SidebarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  height: 100vh;
  z-index: 1045;
  transition: transform 0.3s ease-in-out;
  left: auto;
  width: 100%;
  transform: ${({ isVisible }) =>
    isVisible ? "translateX(0)" : "translateX(100%)"};
  background: url(${MobileSidebarBg}) no-repeat top center white;
  background-size: cover;
  background-attachment: local;
`;

export const SidebarHeader = styled.div`
  height: 70px;
  line-height: 70px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SidebarItems = styled.ul`
  margin: 16px 16px 24px 16px;
  background: #ffffff4d;
  border: 1px solid ${colorPalette.blue100};
  backdrop-filter: blur(100px);
  border-radius: 8px;
  overflow: hidden;
`;

export const NavItem = styled.li.withConfig({
  shouldForwardProp: (prop) => prop !== "isActive" && prop !== "isDeactivated",
})<{ isActive: boolean; isDeactivated: boolean }>`
  list-style-type: none;
  border-bottom: 1px solid ${colorPalette.blue200};

  button {
    width: 100%;
    color: ${({ isDeactivated, isActive }) =>
      isDeactivated ? colorPalette.blue800 : isActive ? colorPalette.blue500 : colorPalette.blue800} !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: opacity 0.3s ease-in-out;
    padding: 24px 16px;
    gap: 12px;
    opacity: ${({ isDeactivated }) => (isDeactivated ? "0.3" : "1")};
    cursor: ${({ isDeactivated }) => (isDeactivated ? "default" : "pointer")};
    ${typeScale.bodySM}
  }

  &:hover {
    opacity: ${({ isActive, isDeactivated }) =>
      !isActive && !isDeactivated ? "0.7" : "1"};
    cursor: pointer;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const LogoImage = styled.img`
  width: 125px;
  cursor: pointer;
`;

export const NotificationDot = styled.div`
  position: absolute;
  bottom: 0px; /* Adjusted to be fully visible */
  right: 0px;
  width: 8px; /* Slightly larger for visibility */
  height: 8px;
  background-color: #c0392b; /* Red */
  border-radius: 50%;
  border: 1px solid white; /* Ensures a clear white outline */
  display: flex;
  align-items: center;
  justify-content: center;
`;
